import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import LeadForm from '@/components/LeadForm';

const CTASection = () => {
  return (
    <section
      data-testid="cta-section"
      className="relative py-32 overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=2400&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-[#2D2D2D]/85" />
      </div>

      <div className="container-main relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="text-white">
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
              Let's Start Your Project
            </span>
            <h2
              data-testid="cta-title"
              className="font-heading text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight"
            >
              Ready to Transform Your Space?
            </h2>
            <p className="text-white/80 leading-relaxed mb-8 text-lg">
              Book your complimentary consultation today and let's discuss how
              we can bring your vision to life. Our team is ready to create a
              personalized plan for your home.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:+18888801455">
                <Button
                  data-testid="cta-call-btn"
                  className="btn-accent px-10"
                >
                  Call +1-888-880-1455
                </Button>
              </a>
            </div>
          </div>

          {/* Right Form */}
          <div className="bg-white p-8 md:p-10 rounded-sm">
            <h3 className="font-heading text-2xl text-[#2D2D2D] mb-6">
              Request Your Consultation
            </h3>
            <LeadForm variant="compact" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
